import { render, staticRenderFns } from "./organiz_manage.vue?vue&type=template&id=170c8396&scoped=true&"
import script from "./organiz_manage.vue?vue&type=script&lang=js&"
export * from "./organiz_manage.vue?vue&type=script&lang=js&"
import style0 from "./organiz_manage.vue?vue&type=style&index=0&id=170c8396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c8396",
  null
  
)

export default component.exports